export default "__VITE_ASSET__DN_Vuy3j__"